import { Spin } from "antd";
import axios from "axios";
import React, { useContext, useRef, useState } from "react";

import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-hot-toast";

import PsContext from "../../../context";

import { upperCase } from "../../../utils";
import { PAGE_LAYOUT, PAGE_SIZE } from "../../../utils/data";
import { ServiceUrl } from "../../../utils/serviceUrl";

const AddStudentCertificate = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const buttonRef = useRef(null);

  const [dataList, setDataList] = useState([]);
  const [editorContent, setEditorContent] = useState("");

  const [validated, setValidated] = useState(false);

  const field = (fieldName) => {
    return dataList && dataList[fieldName];
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    if (!window.confirm("Do you want to save ?")) return;
    setLoader(true);
    axios
      .post(ServiceUrl.UTILITIES.CREATE_STUDENT_CERTIFICATE, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          toast.success(res["data"].message || "Success");
          form.reset();
          if (props.onSuccess) props.onSuccess();
        } else toast.error(res["data"].message || "Error");
        setLoader(false);
      });
  };

  return (
    <>
      <Spin spinning={loader}>
        <Form
          noValidate
          validated={validated}
          action=""
          method="post"
          onSubmit={handleFormSubmit}
        >
          <input type="hidden" name="id" value={field("id")} />

          <Row className="mt-2">
            <Col md={12}>
              <label>Certificate Name (allowed (_) only)</label>
              <Form.Control
                type="text"
                className="fw-bold "
                size="sm"
                name="certificate_name"
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={12}>
              <label>Certificate Title </label>
              <Form.Control
                type="text"
                className="fw-bold "
                size="sm"
                name="certificate_title"
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={12}>
              <label>Certificate For</label>
              <Form.Control
                as="select"
                className="fw-bold form-select form-select-sm"
                size="sm"
                name="certificate_for"
              >
                <option value="">-</option>
                <option value="student">Student</option>
                <option value="staff">Staff</option>
              </Form.Control>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={12}>
              <label>Page Size</label>
              <Form.Control
                as="select"
                className="fw-bold form-select form-select-sm"
                size="sm"
                name="page_size"
                required
              >
                {PAGE_SIZE.map((item) => (
                  <option
                    value={item}
                    selected={item == field("page_size") ? "selected" : ""}
                  >
                    {upperCase(item)}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={12}>
              <label>Page Layout</label>
              <Form.Control
                as="select"
                className="fw-bold form-select form-select-sm"
                size="sm"
                name="page_layout"
                required
              >
                {PAGE_LAYOUT.map((item) => (
                  <option
                    value={item}
                    selected={item == field("page_layout") ? "selected" : ""}
                  >
                    {upperCase(item)}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Row>

          <Row className="mt-3 mb-4">
            <Col md={12}>
              <div className="text-end">
                <Button type="submit" size="sm" ref={buttonRef}>
                  <i className="fa-solid fa-check fs-6 px-1"></i>Update
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
export default AddStudentCertificate;
